export interface ISalesCategory {
  category_name: string;
  total: number;
  color?: string;
  count?: number;
}
